/**
 * Lizard 微交互彩蛋系统 v3.0
 * 台球拱形滚动 + 返回顶部台球弹跳
 */

(function() {
  'use strict';

  var isReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (isReduced) return;

  /* ========================================
     特效1：台球拱形滚动动画
     每次滚动，大号银球从左到右划拱形圆弧
     ======================================== */
  var ballContainer = null;
  var lastScrollTime = 0;
  var scrollThrottle = 800; // 滚动节流（毫秒）

  function createRollingBall() {
    if (ballContainer) return;

    ballContainer = document.createElement('div');
    ballContainer.id = 'lizard-rolling-ball';
    ballContainer.setAttribute('aria-hidden', 'true');
    ballContainer.innerHTML = '\
      <svg viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg">\
        <defs>\
          <radialGradient id="silverBall" cx="30%" cy="30%" r="70%">\
            <stop offset="0%" style="stop-color:#ffffff;stop-opacity:1"/>\
            <stop offset="30%" style="stop-color:#f8f8f8;stop-opacity:1"/>\
            <stop offset="50%" style="stop-color:#e8e8e8;stop-opacity:1"/>\
            <stop offset="70%" style="stop-color:#c0c0c0;stop-opacity:1"/>\
            <stop offset="90%" style="stop-color:#a0a0a0;stop-opacity:1"/>\
            <stop offset="100%" style="stop-color:#808080;stop-opacity:1"/>\
          </radialGradient>\
        </defs>\
        <circle cx="40" cy="40" r="38" fill="url(#silverBall)"/>\
        <ellipse cx="24" cy="26" rx="12" ry="8" fill="rgba(255,255,255,0.85)" transform="rotate(-35 24 26)"/>\
      </svg>\
    ';
    document.body.appendChild(ballContainer);

    // 动画结束后移除（延长到2.8秒确保完整播放）
    setTimeout(function() {
      if (ballContainer && ballContainer.parentNode) {
        ballContainer.parentNode.removeChild(ballContainer);
        ballContainer = null;
      }
    }, 2800);
  }

  function triggerRollingBall() {
    var now = Date.now();
    if (now - lastScrollTime < scrollThrottle) return; // 节流
    lastScrollTime = now;

    if (window.innerWidth < 768) return; // 仅桌面端

    // 移除旧的球（如果存在）
    if (ballContainer && ballContainer.parentNode) {
      ballContainer.parentNode.removeChild(ballContainer);
      ballContainer = null;
    }

    // 创建新球
    createRollingBall();

    // 触发动画
    if (ballContainer) {
      setTimeout(function() {
        if (ballContainer) {
          ballContainer.classList.add('is-rolling');
        }
      }, 50);
    }
  }

  function initRollingBall() {
    // 立即检查是否需要触发
    triggerRollingBall();

    // 监听滚动
    window.addEventListener('scroll', triggerRollingBall, { passive: true });
  }

  /* ========================================
     特效2：返回顶部按钮点击弹跳
     改为银色台球样式
     ======================================== */
  function initBackToTopBounce() {
    var backTopBtn = document.querySelector('.hdt-back-to-top');
    if (!backTopBtn) return;

    // 添加银色台球样式类
    backTopBtn.classList.add('lizard-billiard-btn');

    var isAnimating = false;

    // 点击时添加弹跳动画
    backTopBtn.addEventListener('click', function(e) {
      if (isAnimating) return;

      isAnimating = true;
      backTopBtn.classList.add('lizard-bounce-animation');

      // 动画结束后清理
      setTimeout(function() {
        backTopBtn.classList.remove('lizard-bounce-animation');
        isAnimating = false;
      }, 900);
    });
  }

  /* ========================================
     初始化
     ======================================== */
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(function() {
          initRollingBall();
          initBackToTopBounce();
        }, 500);
      });
    } else {
      setTimeout(function() {
        initRollingBall();
        initBackToTopBounce();
      }, 500);
    }
  }

  // 等待preloader完成
  if (document.getElementById('ecomus-preloader')) {
    window.addEventListener('ecomus-preloader-hidden', function() {
      setTimeout(init, 300);
    });
  } else {
    init();
  }

})();